<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Novo Contrato
      </v-card-title>
      <v-card-text>
        <v-menu
          ref="menu"
          v-model="menuSigned_at"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="signed_at"
              label="Data de assinatura"
              prepend-icon="mdi-calendar"
              :state="stateErrors.signed_at"
              :error-messages="errors.signed_at"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            ref="picker"
            v-model="signed_at"
            min="1990-01-01"
            @change="menuSigned_at = false"
          />
        </v-menu>
        <v-menu
          ref="menu"
          v-model="menuStarts_at"
          :close-on-content-click="false"
          transition="scale-transition"
          :state="true"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="starts_at"
              label="Data de inicio"
              prepend-icon="mdi-calendar"
              :state="true"
              :error-messages="errors.starts_at"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            ref="picker"
            v-model="starts_at"
            :state="true"
            :error-messages="errors.starts_at"
            min="1990-01-01"
            @change="menuStarts_at = false"
          />
        </v-menu>
        <v-menu
          ref="menu"
          v-model="menuExpires_at"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          :disabled="starts_at === '' ? true : false"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="expires_at"
              :label="starts_at === '' ? 'Selecione a data inicial' :'Data final'"
              prepend-icon="mdi-calendar"
              readonly
              :disabled="starts_at === '' ? true : false"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            ref="picker"
            v-model="expires_at"
            :min="starts_at"
            @change="menuExpires_at = false"
          />
        </v-menu>
        <v-menu
          ref="menu"
          v-model="menuRenews_at"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          :disabled="starts_at === '' ? true : expires_at === '' ? true : false"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="renews_at"
              :label="starts_at === '' ? 'Selecione a data inicial' : expires_at === '' ? 'Selecione a data final' : 'Data de renovação'"
              prepend-icon="mdi-calendar"
              readonly
              :disabled="starts_at === '' ? true : expires_at === '' ? true : false"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            ref="picker"
            v-model="renews_at"
            @change="menuRenews_at = false"
          />
        </v-menu>
        <div class="row d-flex justify-space-between mt-4">
          <v-btn
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="onSubmit"
          >
            Salvar contrato
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import utils from '@/api/utils.js'

export default {
  components: {
  },
  props: {
    id: { type: Number, required: true }
  },

  data: () => ({
    formError: {},
    modalNewContract: false,
    menuSigned_at: false,
    menuStarts_at: false,
    menuExpires_at: false,
    menuRenews_at: false,
    signed_at: '',
    starts_at: '',
    expires_at: '',
    renews_at: '',
    errors: [],
    stateErrors: []
  }),
  methods: {
    getErrors (data) {
      if (data.data.errors) {
        this.errors = utils.setErrorsData(data.data.errors)
        this.stateErrors = utils.setStateErrors(data.data.errors)
      } else {
        throw (data)
      }
    },
    validates () {
      return this.$refs.form.validate()
    },

    onCancel () {
      this.$emit('resolve', false)
    },
    async onSubmit () {
      const data = {
        signed_at: this.signed_at,
        starts_at: this.starts_at,
        expires_at: this.expires_at,
        renews_at: this.renews_at
      }
      try {
        const response = await this.$api.newContract(this.id, data)
        this.$emit('resolve', response)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível criar o contrato, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e.response)
      }
    }
  }
}
</script>
